/**
 * Work-permit warnings in words (spec 3.18, Phase 5), PURE and shared, so the server's notices and the client's roster,
 * banner and My info say them the same way, and the anchors a notice lands on. A notice counts the days, never names
 * the date; the pages show the date. The rule behind the words (the days left, the stages, "missing") is
 * child-performer.ts.
 */
/** My info's quick check: where a nudge and the quick_check to-do land (`/portal/me/info?record=<id>#quick-check`). */
export const QUICK_CHECK_ANCHOR = 'quick-check';
/** My info's permits of a dependent: where a family's permit notice lands (`#permits`). */
export const PERMITS_ANCHOR = 'permits';
/** The most pressing first: an expired permit, then a missing one, then one coming up. */
export const PERMIT_WARNING_ORDER = ['expired', 'missing', 'expiring'];
/** A warning's rank for sorting (0: the most pressing). */
export const permitRank = (kind) => PERMIT_WARNING_ORDER.indexOf(kind);
/** A warning's short label (the roster badge). */
export const PERMIT_BADGE = { expired: 'Permit expired', expiring: 'Permit expiring', missing: 'Permit missing' };
/** A warning as the state of the permit ("Work permit expired: Kid Park"). */
export const PERMIT_STATE = { expired: 'expired', expiring: 'expiring soon', missing: 'missing' };
/** A missing permit, wherever it is said. */
export const PERMIT_MISSING_TEXT = 'No work permit expiry date is on file where one is required.';
/**
 * Whose date a permit warning counts, said to the agency where it acts on it: the profile field and the child performer
 * record hold separate dates and the earlier one counts, so a later date typed in the profile does not clear a warning
 * that runs on the performer record's.
 */
export const PERMIT_SOURCE_TEXT = {
    agency: 'That date is from your client profile.',
    talent: 'That date is on the child performer record, not the client profile.',
};
/** When a dated permit expires or expired, counted in days (a notice never names the date): "expires in 9 days". */
export function permitWhen(daysLeft) {
    if (daysLeft < 0)
        return daysLeft === -1 ? 'expired yesterday' : `expired ${-daysLeft} days ago`;
    if (daysLeft === 0)
        return 'expires today';
    return daysLeft === 1 ? 'expires tomorrow' : `expires in ${daysLeft} days`;
}
//# sourceMappingURL=permits.js.map